
import { MetricInstance } from "./MetricInstance";

const setSideDrawerConfig = (attributes) => {
  let sideDrawerConfig = new MetricInstance(
                                                null,  //nameOverride
                                                null,  //timePeriod
                                                2,     //decimalPlaces
                                                null,  //annualizedCumulative
                                                null,  //dailyMonthly
                                                null,  //averageEnding
                                                false, //residuals
                                                null, //customTimePeriod
                                                null,  //fixedTrailing
                                                null,  //excessReturns
                                                15,     // maxDecimalPlaces
                                                true,  //includeMax
                                                null  //displayName
                                              );

  

    Object.keys(attributes).length > 0 && Object.keys(attributes).forEach((key) => {
      sideDrawerConfig[key] = attributes[key];
    })
  return sideDrawerConfig;
}

// NEW metrics TP List. The Old one is removed and changed place of object.
export const TIME_PERIOD_OPTIONS = {
  Daily: { label: "1 Day", displayName: "Daily", name: "Daily" },
  W1: { label: "1 Week", displayName: "W1", name: "W1" },
  MTD: { label: "MTD", displayName: "MTD", name: "MTD" },
  M1: { label: "1 Month", displayName: "M1", name: "M1" },
  QTD: { label: "QTD", displayName: "QTD", name: "QTD" },
  M3: { label: "3 Month", displayName: "M3", name: "M3" },
  YTD: { label: "YTD", displayName: "YTD", name: "YTD" },
  Y1: { label: "1 Yr", displayName: "Y1", name: "Y1" },  
  Y3_Annualized: { label: "3 Yr-Ann", displayName: "Y3 Annualized", name: "Y3_Annualized" },
  Y3_Cumulative: { label: "3 Yr-Cum", displayName: "Y3 Cumulative", name: "Y3_Cumulative" },  
  Y5_Annualized: { label: "5 Yr-Ann", displayName: "Y5 Annualized", name: "Y5_Annualized" },
  Y5_Cumulative: { label: "5 Yr-Cum", displayName: "Y5 Cumulative", name: "Y5_Cumulative" },  
  Y7_Annualized: { label: "7 Yr-Ann", displayName: "Y7 Annualized", name: "Y7_Annualized" },
  Y7_Cumulative: { label: "7 Yr-Cum", displayName: "Y7 Cumulative", name: "Y7_Cumulative" },  
  Y10_Annualized: { label: "10 Yr-Ann", displayName: "Y10 Annualized", name: "Y10_Annualized" },
  Y10_Cumulative: { label: "10 Yr-Cum", displayName: "Y10 Cumulative", name: "Y10_Cumulative" },
  ITD: { label: "ITD", displayName: "ITD", name: "ITD" },
  ITD_Annualized: { label: "ITD-Ann", displayName: "ITD Annualized", name: "ITD_Annualized" },
  ITD_Cumulative: { label: "ITD-Cum", displayName: "ITD Cumulative", name: "ITD_Cumulative" },  
}

const greaterThanMonthTimeperiods = [ TIME_PERIOD_OPTIONS.MTD, TIME_PERIOD_OPTIONS.M1,
  TIME_PERIOD_OPTIONS.QTD, TIME_PERIOD_OPTIONS.M3, TIME_PERIOD_OPTIONS.YTD, TIME_PERIOD_OPTIONS.Y1,
  TIME_PERIOD_OPTIONS.Y3_Annualized, TIME_PERIOD_OPTIONS.Y3_Cumulative,
  TIME_PERIOD_OPTIONS.Y5_Annualized, TIME_PERIOD_OPTIONS.Y5_Cumulative,
  TIME_PERIOD_OPTIONS.Y7_Annualized, TIME_PERIOD_OPTIONS.Y7_Cumulative, 
  TIME_PERIOD_OPTIONS.Y10_Annualized, TIME_PERIOD_OPTIONS.Y10_Cumulative, TIME_PERIOD_OPTIONS.ITD,
  TIME_PERIOD_OPTIONS.ITD_Annualized, TIME_PERIOD_OPTIONS.ITD_Cumulative ];
const greaterThanYearTimeperiods = [ TIME_PERIOD_OPTIONS.Y1,
  TIME_PERIOD_OPTIONS.Y3_Annualized, TIME_PERIOD_OPTIONS.Y3_Cumulative,
  TIME_PERIOD_OPTIONS.Y5_Annualized, TIME_PERIOD_OPTIONS.Y5_Cumulative,
  TIME_PERIOD_OPTIONS.Y7_Annualized, TIME_PERIOD_OPTIONS.Y7_Cumulative, 
  TIME_PERIOD_OPTIONS.Y10_Annualized, TIME_PERIOD_OPTIONS.Y10_Cumulative, TIME_PERIOD_OPTIONS.ITD,
  TIME_PERIOD_OPTIONS.ITD_Annualized, TIME_PERIOD_OPTIONS.ITD_Cumulative ];
const allTimeperiods = [ TIME_PERIOD_OPTIONS.Daily, TIME_PERIOD_OPTIONS.W1, TIME_PERIOD_OPTIONS.MTD, 
  TIME_PERIOD_OPTIONS.M1, TIME_PERIOD_OPTIONS.QTD, TIME_PERIOD_OPTIONS.M3, TIME_PERIOD_OPTIONS.YTD, 
  TIME_PERIOD_OPTIONS.Y1, TIME_PERIOD_OPTIONS.Y3_Annualized, TIME_PERIOD_OPTIONS.Y3_Cumulative,
  TIME_PERIOD_OPTIONS.Y5_Annualized, TIME_PERIOD_OPTIONS.Y5_Cumulative,
  TIME_PERIOD_OPTIONS.Y7_Annualized, TIME_PERIOD_OPTIONS.Y7_Cumulative, 
  TIME_PERIOD_OPTIONS.Y10_Annualized, TIME_PERIOD_OPTIONS.Y10_Cumulative, TIME_PERIOD_OPTIONS.ITD,
  TIME_PERIOD_OPTIONS.ITD_Annualized, TIME_PERIOD_OPTIONS.ITD_Cumulative ];

// Sync Timeperiods for groups
const contributionSyncTimeperiods = ['Contribution', 'Contribution Residual'];
const attributionSyncTimeperiods = ['Asset Allocation', 'Stock Selection','Total Management Effects','Attribution Residual'];

  // To add any new metric, metric should be added to below metricConfig, with required
  // params as maintained previously. This metric will char section will be utilised to generate
  // chart_types 
  // groupName - To find metriccode for old QS
  // displayName -  To display in Grid col Gen
  // gridDisplayName -  To overide display name in grid column header

export const metricConfig = {
    EndMarketValueWithAccrual: {
      code: 'EndMarketValueWithAccrual',
      groupName: 'Ending Market Value',
      displayName: 'Market Value',
      shortName: 'EMV',
      symbol: '($)',
      showCurrency: true,
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: 'Ending',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      applicableGroup: ['Account'], // added attribute to remove BLACK_LISTED_METRICS object which we are maintaining separately.
      sideDrawerConfig: setSideDrawerConfig({
            decimalPlaces: 0,
            maxDecimalPlaces: 2,
            includeMax: false,
            sidePanelDisplayName: 'Ending Market Value'
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric:true,
      showAccrued: true
    },
    BeginMarketValueWithAccrual: {
      code: 'BeginMarketValueWithAccrual',
      groupName: 'Market Value (Beginning)',
      displayName: 'Market Value (Beginning)',
      gridDisplayName: 'Market Value',
      shortName: 'BMV',
      symbol: '($)',
      showCurrency: true,
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: 'Beginning',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      applicableGroup: ['Account'], // added attribute to remove BLACK_LISTED_METRICS object which we are maintaining separately.
      sideDrawerConfig: setSideDrawerConfig({
            decimalPlaces: 0,
            maxDecimalPlaces: 2,
            includeMax: false,
            sidePanelDisplayName: 'Beginning Market Value'
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      showAccrued: true
    },
    EndMarketValueWithAccrualLocal: {
      code: 'EndMarketValueWithAccrualLocal',
      groupName: 'Ending Market Value Local',
      displayName: 'Market Value Local',
      shortName: 'EMV Local',
      symbol: '($)',
      showCurrency: true,
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: 'Ending',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      applicableGroup: ['Account'], // added attribute to remove BLACK_LISTED_METRICS object which we are maintaining separately.
      sideDrawerConfig: setSideDrawerConfig({
            decimalPlaces: 0,
            maxDecimalPlaces: 2,
            includeMax: false,
            sidePanelDisplayName: 'Ending Market Value'
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      showAccrued: true
    },
    BeginMarketValueWithAccrualLocal: {
      code: 'BeginMarketValueWithAccrualLocal',
      groupName: 'Market Value Local (Beginning)',
      displayName: 'Market Value Local (Beginning)',
      gridDisplayName: 'Market Value Local',
      shortName: 'BMV Local',
      symbol: '($)',
      showCurrency: true,
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: 'Beginning',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      applicableGroup: ['Account'], // added attribute to remove BLACK_LISTED_METRICS object which we are maintaining separately.
      sideDrawerConfig: setSideDrawerConfig({
            decimalPlaces: 0,
            maxDecimalPlaces: 2,
            includeMax: false,
            sidePanelDisplayName: 'Beginning Market Value'
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      showAccrued: true
    },
    RateOfReturn: {
      code: 'RateOfReturn',
      groupName: 'Rate of Return',
      displayName: 'Rate of Return',
      shortName: 'ROR',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_RateOfReturn_XXXXXXXX',
        },
        cumulative: {
          field: 'Custom_Cumulative_RateOfReturn_XXXXXXXX',
        },
        field: `Custom_RateOfReturn_XXXXXXXX`,
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        fixedTrailing: "Trailing",
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric:true,
      applicableTimeperiods: allTimeperiods
    },
    RateOfReturnLocal: {
      code: 'RateOfReturnLocal',
      groupName: 'Rate of Return Local',
      displayName: 'Rate of Return Local',
      shortName: 'ROR Local',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_RateOfReturnLocal_XXXXXXXX',
        },
        cumulative: {
          field: 'Custom_Cumulative_RateOfReturnLocal_XXXXXXXX',
        },
        field: `Custom_RateOfReturnLocal_XXXXXXXX`,
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        fixedTrailing: "Trailing",
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods,
      appendUnderscoreIndexForBenchmark : true
    },
    Contribution: {
      code: 'Contribution',
      groupName: 'Contribution',
      displayName: 'Contribution',
      shortName: 'CONTRIBUTION',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_Contribution_XXXXXXXX',
        },
        cumulative: {
          field: 'Custom_Cumulative_Contribution_XXXXXXXX',
        },
        field: 'Custom_Contribution_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: contributionSyncTimeperiods
    },
    Residual: {
      code: 'Residual',
      groupName: 'Contribution Residual',
      displayName: 'Contribution Residual',
      gridDisplayName: 'Contrib. Res.',
      shortName: 'CONTRIBUTION_RESIDUAL',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_Residual_XXXXXXXX',
        },
        cumulative: {
          field: 'Custom_Cumulative_Residual_XXXXXXXX',
        },
        field: 'Custom_Residual_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: contributionSyncTimeperiods
    },
    WeightEnding: {
      code: 'WeightEnding',
      groupName: 'Weight',
      displayName: 'Weight Ending',
      shortName: 'Weight',
      symbol: '(%)',
      headerLogic: 'None',
      appendToHeader: 'Ending',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_WeightEnding_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      averageEnding: 'Ending'
    },
    WeightAverage: {
      code: 'WeightAverage',
      groupName: 'Weight',
      displayName: 'Weight Average',
      shortName: 'Weight',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: 'Average',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_WeightAverage_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods,
      averageEnding: 'Average'
    },
    WeightEndingAbsolute: {
      code: 'WeightEndingAbsolute',
      groupName: 'Weight Ending (Total Fund)',
      displayName: 'Weight Ending (Total Fund)',
      shortName: 'Weight TF',
      symbol: '(%)',
      headerLogic: 'None',
      appendToHeader: 'Ending',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_WeightEndingAbsolute_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      averageEnding: 'Ending'
    },
    WeightAverageAbsolute: {
      code: 'WeightAverageAbsolute',
      groupName: 'Weight Average (Total Fund)',
      displayName: 'Weight Average (Total Fund)',
      shortName: 'Weight Avg TF',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: 'Average',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_WeightAverage_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      averageEnding: 'Average'
    },
    StandardDeviationDaily: {
      code: 'StandardDeviationDaily', // Frequency toggle change will be handle seperately in StandardDeviationDaily/Monthly merge as one metric 
      groupName: 'Standard Deviation',
      displayName: 'Standard Deviation',
      shortName: 'STANDARD_DEVIATION_DAILY',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '(Daily)',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_StandardDeviationDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      dailyMonthly : 'Daily'
    },
    StandardDeviationMonthly: {
      code: 'StandardDeviationMonthly',
      groupName: 'Standard Deviation (Monthly)',
      displayName: 'Standard Deviation (Monthly)',
      shortName: 'STANDARD_DEVIATION_MONTHLY',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '(Monthly)',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_StandardDeviationMonthly_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: greaterThanYearTimeperiods,
      dailyMonthly : 'Monthly'
    },
    StandardDeviationSampleDaily: {
      code: 'StandardDeviationSampleDaily',
      groupName: 'Standard Deviation (Sample)',
      displayName: 'Standard Deviation (Sample)',
      shortName: 'StandardDeviationSampleDaily',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_StandardDeviationSampleDaily_XXXXXXXX',
        },
        cumulative: {
          field: 'Custom_Cumulative_StandardDeviationSampleDaily_XXXXXXXX',
        },
        field: 'Custom_StandardDeviationSampleDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods
    },
    StockSelection: {
      code: 'StockSelection',
      groupName: 'Stock Selection',
      displayName: 'Stock Selection',
      shortName: 'STOCK_SELECTION',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_StockSelection_XXXXXXXX`,
      },
      applicableGroup: ['Attribution'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: attributionSyncTimeperiods
    },
    UnhedgedCurrency: {
      code: 'UnhedgedCurrency',
      groupName: 'Unhedged Currency',
      displayName: 'Unhedged Currency',
      shortName: 'UNHEDGED_CURRENCY',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_UnhedgedCurrency_XXXXXXXX`,
      },
      applicableGroup: ['Attribution'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: attributionSyncTimeperiods
    },
    AssetAllocation: {
      code: 'AssetAllocation',
      groupName: 'Asset Allocation',
      displayName: 'Asset Allocation',
      shortName: 'ASSET_ALLOCATION',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_AssetAllocation_XXXXXXXX`,
      },
      applicableGroup: ['Attribution'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: attributionSyncTimeperiods
    },
    TotalManagementEffects: {
      code: 'TotalManagementEffects',
      groupName: 'Total Management Effects',
      displayName: 'Total Management Effects',
      shortName: 'TOTAL_MANAGEMENT_EFFECT',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          id: 14,
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          id: 15,
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_TotalManagementEffects_XXXXXXXX`,
      },
      applicableGroup: ['Attribution'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: attributionSyncTimeperiods
    },
    AttributionResidual: {
      code: 'AttributionResidual',
      groupName: 'Attribution Residual',
      displayName: 'Attribution Residual',
      shortName: 'ATTRIBUTION_RESIDUAL',
      gridDisplayName: 'Attrib. Res.',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          id: 14,
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          id: 15,
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_AttributionResidual_XXXXXXXX`,
      },
      applicableGroup: ['Attribution'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
      syncTimeperiodsGroup: attributionSyncTimeperiods
    },
    ExcessReturns: {
      code: 'ExcessReturns',
      groupName: 'Excess Returns (Absolute)',
      displayName: 'Excess Returns (Absolute)',
      shortName: 'EXCESS_RETURNS',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: 'Absolute',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_ExcessReturns_XXXXXXXX`,
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods,
      excessReturns: 'Absolute',
      isIHAllBenchmark: true,
    },
    RelativeExcessReturn : {
      code : 'RelativeExcessReturn',
      groupName : 'Excess Returns (Relative)',
      displayName: 'Excess Returns (Relative)',
      shortName: 'EXCESS_RETURNS_RELATIVE',
      symbol : '(%)',
      headerLogic : 'useTimePeriod',
      appendToHeader : 'Relative',
      fieldLogic : 'useTimePeriod',
      charts: [
          {
            chartType: 'Basic Bar',
            iconName: 'chart_bar',
          },
          {
            chartType: 'Basic Column',
            iconName: 'chart_bar',
          },
        ],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_RelativeExcessReturn_XXXXXXXX`
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods,
      excessReturns: 'Relative',
      isIHAllBenchmark: true,
    },
    InceptionDate : {
      code : 'InceptionDate',
      groupName : 'Inception Date',
      displayName: 'Inception Date',
      shortName: 'INCEPTION_DATE',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'DateFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_InceptionDate_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    lastlockperformance : {
      code : 'lastlockperformance',
      groupName : 'Last Lock Performance',
      displayName: 'Last Lock Performance',
      shortName: 'LAST_LOCK_PERFORMANCE',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'DateFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_lastlockperformance_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    lastlockclient : {
      code : 'lastlockclient',
      groupName : 'Last Lock Client',
      displayName: 'Last Lock Client',
      shortName: 'LAST_LOCK_CLIENT',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'DateFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_lastlockclient_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    SEDOL : {
      code : 'SEDOL',
      groupName : 'SEDOL',
      displayName: 'SEDOL',
      shortName: 'SEDOL',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_SEDOL_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    CUSIP : {
      code : 'CUSIP',
      groupName : 'CUSIP',
      displayName: 'CUSIP',
      shortName: 'CUSIP',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_CUSIP_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    ISIN : {
      code : 'ISIN',
      groupName : 'ISIN',
      displayName: 'ISIN',
      shortName: 'ISIN',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_ISIN_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    TICKER : {
      code : 'TICKER',
      groupName : 'TICKER',
      displayName: 'TICKER',
      shortName: 'TICKER',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_TICKER_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    AIPInstrumentID : {
      code : 'AIPInstrumentID',
      groupName : 'AIP Instrument ID',
      displayName: 'AIP Instrument ID',
      shortName: 'AIPINSTRUMENTID',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_AIPInstrumentID_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    OmniumAssetID : {
      code : 'OmniumAssetID',
      groupName : 'Omnium Asset ID',
      displayName: 'Omnium Asset ID',
      shortName: 'OMNIUMASSETID',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_OmniumAssetID_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    AssetCurrency : {
      code : 'AssetCurrency',
      groupName : 'Asset Currency',
      displayName: 'Asset Currency',
      shortName: 'ASSETCURRENCY',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_AssetCurrency_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    AssetIssueType : {
      code : 'AssetIssueType',
      groupName : 'Asset Issue Type',
      displayName: 'Asset Issue Type',
      shortName: 'ASSETISSUETYPE',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_AssetIssueType_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    AssetName : {
      code : 'AssetName',
      groupName : 'Asset Name',
      displayName: 'Asset Name',
      shortName: 'ASSETNAME',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_AssetName_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    AssetNameBBRG : {
      code : 'AssetNameBBRG',
      groupName : 'Asset Name Bloomberg',
      displayName: 'Asset Name Bloomberg',
      shortName: 'ASSETNAMEBBRG',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_AssetNameBBRG_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    CountryOfDomicile : {
      code : 'CountryOfDomicile',
      groupName : 'Country Of Domicile',
      displayName: 'Country Of Domicile',
      shortName: 'COUNTRYOFDOMICILE',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_CountryOfDomicile_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    IssuerName : {
      code : 'IssuerName',
      groupName : 'Issuer Name',
      displayName: 'Issuer Name',
      shortName: 'ISSUERNAME',
      symbol : '',
      headerLogic : 'None',
      appendToHeader : 'Informational',
      fieldLogic : 'None',
      charts: [],
      workspaceType : ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
          isAnnualizedCumulative: false,
          field: `Custom_IssuerName_XXXXXXXX`
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      hideDecimalDropdown: true,
      isTimePeriodMetric: false
    },
    PlusFlow: {
      code: 'PlusFlow',
      groupName: 'Plus Flow',
      displayName: 'Plus Flow',
      shortName: 'PlusFlow',
      symbol: '',
      headerLogic: 'useTimePeriod', // Nothing will be in header will simply append appendToHeader
      appendToHeader: '',
      fieldLogic: 'useTimePeriod', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_PlusFlow_XXXXXXXX`
      },
      defaultTimeperiod: 'Daily',
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods
    },
    MinusFlow: {
      code: 'MinusFlow',
      groupName: 'Minus Flow',
      displayName: 'Minus Flow',
      shortName: 'MinusFlow',
      symbol: '',
      headerLogic: 'useTimePeriod', // Nothing will be in header will simply append appendToHeader
      appendToHeader: '',
      fieldLogic: 'useTimePeriod', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_MinusFlow_XXXXXXXX`
      },
      defaultTimeperiod: 'Daily',
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods
    },
    BeginAccrual: {
      code: 'BeginAccrual',
      groupName: 'Beginning Accrual',
      displayName: 'Beginning Accrual',
      shortName: 'BeginAccrual',
      symbol: '',
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: '',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      defaultTimeperiod: 'Daily',
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
    },
    EndAccrual: {
      code: 'EndAccrual',
      groupName: 'Ending Accrual',
      displayName: 'Ending Accrual',
      shortName: 'EndAccrual',
      symbol: '',
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: '',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      defaultTimeperiod: 'Daily',
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
    },
    BeginAdjustment: {
      code: 'BeginAdjustment',
      groupName: 'Beginning Adjustment',
      displayName: 'Beginning Adjustment',
      shortName: 'BeginAdjustment',
      symbol: '',
      headerLogic: 'None', // Nothing will be in header will simply append appendToHeader
      appendToHeader: '',
      fieldLogic: 'None', // simply use the code
      charts: [
        {
          chartType: 'Basic Pie',
          iconName: 'chart_pie',
        },
        {
          chartType: 'Basic Doughnut',
          iconName: 'chart_donut',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      defaultTimeperiod: 'Daily',
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
    },
    ActiveShare: {
      code: 'ActiveShare',
      groupName: 'Active Share',
      displayName: 'Active Share',
      shortName: 'ACTIVE_SHARE',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: false,
      isIHAllBenchmark: true,
    },
    TrackingError: {
      code: 'TrackingError',
      groupName: 'Tracking Error',
      displayName: 'Tracking Error',
      shortName: 'TRACKING_ERROR',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_TrackingError_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    SharpeRatioDaily: {
      code: 'SharpeRatioDaily',
      groupName: 'Sharpe Ratio',
      displayName: 'Sharpe Ratio',
      shortName: 'SHARP_RATIO_DAILY',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_SharpeRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods
    },
    InformationRatioDaily: {
      code: 'InformationRatioDaily',
      groupName: 'Information Ratio',
      displayName: 'Information Ratio',
      shortName: 'InformationRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_InformationRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    RSquaredDaily: {
      code: 'RSquaredDaily',
      groupName: 'R-Squared',
      displayName: 'R-Squared',
      shortName: 'RSquaredDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_RSquaredDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    BetaDaily: {
      code: 'BetaDaily',
      groupName: 'Beta',
      displayName: 'Beta',
      shortName: 'BETA_DAILY',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_BetaDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    JensenAlphaDaily: {
      code: 'JensenAlphaDaily',
      groupName: 'Jensen Alpha',
      displayName: 'Jensen Alpha',
      shortName: 'JENSEN_ALPHA_DAILY',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_JensenAlphaDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    SortinoRatioDaily: {
      code: 'SortinoRatioDaily',
      groupName: 'Sortino Ratio',
      displayName: 'Sortino Ratio',
      shortName: 'SORTINO_RATIO_DAILY',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_SortinoRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods
    },
    UpsideMarketCaptureRatioDaily: {
      code: 'UpsideMarketCaptureRatioDaily',
      groupName: 'Upside Market Capture Ratio',
      displayName: 'Upside Market Capture Ratio',
      shortName: 'UpsideMarketCaptureRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_UpsideMarketCaptureRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    DownsideMarketCaptureRatioDaily: {
      code: 'DownsideMarketCaptureRatioDaily',
      groupName: 'Downside Market Capture Ratio',
      displayName: 'Downside Market Capture Ratio',
      shortName: 'DownsideMarketCaptureRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_DownsideMarketCaptureRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    DownsideDeviationDaily: {
      code: 'DownsideDeviationDaily',
      groupName: 'Downside Deviation',
      displayName: 'Downside Deviation',
      shortName: 'DOWNSIDE_DEVIATION_DAILY',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_DownsideDeviationDaily_XXXXXXXX',
      },
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods
    },
    InternalRoR: {
      code: 'InternalRoR',
      groupName: 'IRR',
      displayName: 'IRR',
      shortName: 'InternalROR',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: true,
        annualized: {
          field: 'Custom_Annualized_InternalRoR',
        },
        cumulative: {
          field: 'Custom_Cumulative_InternalRoR',
        },
        field: `Custom_InternalRoR_XXXXXXXX`,
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods
    },
    '_12MonthForwardEPS': {
      code: '_12MonthForwardEPS',
      groupName: '12 Month Forward EPS',
      displayName: '12 Month Forward EPS',
      shortName: '12MonthForwardEPS',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
      applicableTimeperiods: allTimeperiods
    },
    '_12MonthTrailingEPS': {
      code: '_12MonthTrailingEPS',
      groupName: '12 Month Trailing EPS',
      displayName: '12 Month Trailing EPS',
      shortName: '12MonthTrailingEPS',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    '_5YearDividendGrowthRate': {
      code: '_5YearDividendGrowthRate',
      groupName: '5 Year Dividend Growth Rate',
      displayName: '5 Year Dividend Growth Rate',
      shortName: '5YearDividendGrowthRate',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None', 
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    '_5YearSalesGrowthRate': {
      code: '_5YearSalesGrowthRate',
      groupName: '5 Year Sales Growth Rate',
      displayName: '5 Year Sales Growth Rate',
      shortName: '5YearSalesGrowthRate',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    '_1YearEPSGrowth': {
      code: '_1YearEPSGrowth',
      groupName: '1 Year EPS Growth',
      displayName: '1 Year EPS Growth',
      shortName: '_1YearEPSGrowth',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    '_5YearsEPSGrowth': {
      code: '_5YearsEPSGrowth',
      groupName: '5 Years EPS Growth',
      displayName: '5 Years EPS Growth',
      shortName: '5YearsEPSGrowth',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    DebtToCapital: {
      code: 'DebtToCapital',
      groupName: 'Debt To Capital',
      displayName: 'Debt To Capital',
      shortName: 'DebtToCapital',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    DebtToEquity: {
      code: 'DebtToEquity',
      groupName: 'Debt To Equity',
      displayName: 'Debt To Equity',
      shortName: 'DebtToEquity',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    DividendYield: {
      code: 'DividendYield',
      groupName: 'Dividend Yield',
      displayName: 'Dividend Yield',
      shortName: 'DividendYield',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    EffectiveDuration: {
      code: 'EffectiveDuration',
      groupName: 'Effective Duration',
      displayName: 'Effective Duration',
      shortName: 'EffectiveDuration',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isWeightingMethodology: true,
    },
    MarketCap: {
      code: 'MarketCap',
      groupName: 'Market Cap',
      displayName: 'Market Cap',
      shortName: 'MarketCap',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    P_E: {
      code: 'P_E',
      groupName: 'PE Ratio Trailing',
      displayName: 'PE Ratio Trailing',
      shortName: 'PERatioTrailing',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    PriceToBookRatio: {
      code: 'PriceToBookRatio',
      groupName: 'Price To Book Ratio',
      displayName: 'Price To Book Ratio',
      shortName: 'PriceToBookRatio',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    PriceToCashFlowRatio: {
      code: 'PriceToCashFlowRatio',
      groupName: 'Price To Cash Flow Ratio',
      displayName: 'Price To Cash Flow Ratio',
      shortName: 'PriceToCashFlowRatio',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    PriceToSalesRatio: {
      code: 'PriceToSalesRatio',
      groupName: 'Price To Sales Ratio',
      displayName: 'Price To Sales Ratio',
      shortName: 'PriceToSalesRatio',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ReturnOnAssets: {
      code: 'ReturnOnAssets',
      groupName: 'Return On Assets',
      displayName: 'Return On Assets',
      shortName: 'ReturnOnAssets',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ReturnOnCapital: {
      code: 'ReturnOnCapital',
      groupName: 'Return On Capital',
      displayName: 'Return On Capital',
      shortName: 'ReturnOnCapital',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ReturnOnEquity: {
      code: 'ReturnOnEquity',
      groupName: 'Return On Equity',
      displayName: 'Return On Equity',
      shortName: 'ReturnOnEquity',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    WeightedAverageMaturity_WAM_: {
      code: 'WeightedAverageMaturity_WAM_',
      groupName: 'Weighted Average Maturity',
      displayName: 'Weighted Average Maturity',
      shortName: 'WeightedAverageMaturity_WAM_',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    AverageLive: {
      code: 'AverageLive',
      groupName: 'Average Life',
      displayName: 'Average Life',
      shortName: 'AverageLive',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    YieldToMaturity: {
      code: 'YieldToMaturity',
      groupName: 'Yield To Maturity',
      displayName: 'Yield To Maturity',
      shortName: 'YieldToMaturity',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    YieldToOption: {
      code: 'YieldToOption',
      groupName: 'Yield To Option',
      displayName: 'Yield To Option',
      shortName: 'YieldToOption',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    YieldToPut: {
      code: 'YieldToPut',
      groupName: 'Yield To Put',
      displayName: 'Yield To Put',
      shortName: 'YieldToPut',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ZeroVolatilitySpread_ZVO_: {
      code: 'ZeroVolatilitySpread_ZVO_',
      groupName: 'Zero Volatility Spread',
      displayName: 'Zero Volatility Spread',
      shortName: 'ZeroVolatilitySpread_ZVO_',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    NominalSpread: {
      code: 'NominalSpread',
      groupName: 'Nominal Spread',
      displayName: 'Nominal Spread',
      shortName: 'NominalSpread',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    MacaulayDuration: {
      code: 'MacaulayDuration',
      groupName: 'Macaulay Duration',
      displayName: 'Macaulay Duration',
      shortName: 'MacaulayDuration',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ModifiedDuration: {
      code: 'ModifiedDuration',
      groupName: 'Modified Duration',
      displayName: 'Modified Duration',
      shortName: 'ModifiedDuration',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    DurationToWorst: {
      code: 'DurationToWorst',
      groupName: 'Duration To Worst',
      displayName: 'Duration To Worst',
      shortName: 'DurationToWorst',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    OptionAdjustedSpread_OAS_: {
      code: 'OptionAdjustedSpread_OAS_',
      groupName: 'Option Adjusted Spread',
      displayName: 'Option Adjusted Spread',
      shortName: 'OptionAdjustedSpread_OAS_',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    EffectiveDurationSpot: {
      code: 'EffectiveDurationSpot',
      groupName: 'Effective Duration Spot',
      displayName: 'Effective Duration Spot',
      shortName: 'EffectiveDurationSpot',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ConvexityToSpot: {
      code: 'ConvexityToSpot',
      groupName: 'Convexity To Spot',
      displayName: 'Convexity To Spot',
      shortName: 'ConvexityToSpot',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    ConvexityToPAR: {
      code: 'ConvexityToPAR',
      groupName: 'Convexity To PAR',
      displayName: 'Convexity To PAR',
      shortName: 'ConvexityToPAR',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRASize: {
      code: 'BARRASize',
      groupName: 'BARRA Size',
      displayName: 'BARRA Size',
      shortName: 'BARRASize',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRAValue: {
      code: 'BARRAValue',
      groupName: 'BARRA Value',
      displayName: 'BARRA Value',
      shortName: 'BARRAValue',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRAMomentum: {
      code: 'BARRAMomentum',
      groupName: 'BARRA Momentum',
      displayName: 'BARRA Momentum',
      shortName: 'BARRAMomentum',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRAGrowth: {
      code: 'BARRAGrowth',
      groupName: 'BARRA Growth',
      displayName: 'BARRA Growth',
      shortName: 'BARRAGrowth',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRALiquidity: {
      code: 'BARRALiquidity',
      groupName: 'BARRA Liquidity',
      displayName: 'BARRA Liquidity',
      shortName: 'BARRALiquidity',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRALeverage: {
      code: 'BARRALeverage',
      groupName: 'BARRA Leverage',
      displayName: 'BARRA Leverage',
      shortName: 'BARRALeverage',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    BARRATrading_Activity_US_: {
      code: 'BARRATrading_Activity_US_',
      groupName: 'BARRA Trading Activity (US)',
      displayName: 'BARRA Trading Activity (US)',
      shortName: 'BARRATrading_Activity_US_',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
      isWeightingMethodology: true,
    },
    AssetCount: {
      code: 'AssetCount',
      groupName: 'Asset Count',
      displayName: 'Asset Count',
      shortName: 'AssetCount',
      symbol: '',
      headerLogic: 'None',
      appendToHeader: '',
      fieldLogic: 'None',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      defaultTimeperiod: 'None',
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: false,
      isTimeSeriesMetric: true,
    },
    NetFlow: {
      code: 'NetFlow',
      groupName: 'Net Flow',
      displayName: 'Net Flow',
      shortName: 'NetFlow',
      symbol: '($)',
      showCurrency: true,
      appendToHeader: '',
      headerLogic: 'useTimePeriod',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_NetFlow_XXXXXXXX`,
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods
    },
    GainLoss: {
      code: 'GainLoss',
      groupName: 'Gain Loss',
      displayName: 'Gain Loss',
      shortName: 'GainLoss',
      symbol: '($)',
      showCurrency: true,
      appendToHeader: '',
      headerLogic: 'useTimePeriod',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
        {
          chartType: 'Basic Column',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: `Custom_GainLoss_XXXXXXXX`,
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 0,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isTimeSeriesMetric: true,
      applicableTimeperiods: allTimeperiods
    },
    TreynorRatioDaily: {
      code: 'TreynorRatioDaily',
      groupName: 'Treynor Ratio',
      displayName: 'Treynor Ratio',
      shortName: 'TreynorRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_TreynorRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    MaximumDrawdownDaily: {
      code: 'MaximumDrawdownDaily',
      groupName: 'Maximum Drawdown',
      displayName: 'Maximum Drawdown',
      shortName: 'MaximumDrawdownDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_MaximumDrawdownDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    CalmarRatioDaily: {
      code: 'CalmarRatioDaily',
      groupName: 'Calmar Ratio',
      displayName: 'Calmar Ratio',
      shortName: 'CalmarRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_CalmarRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Account','Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    RelativeTrackingErrorDaily: {
      code: 'RelativeTrackingErrorDaily',
      groupName: 'Relative Tracking Error',
      displayName: 'Relative Tracking Error',
      shortName: 'RelativeTrackingErrorDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_TrackingError_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    SkewnessDaily: {
      code: 'SkewnessDaily',
      groupName: 'Skewness',
      displayName: 'Skewness',
      shortName: 'SkewnessDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_SkewnessDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    MaximumRecoveryDaily: {
      code: 'MaximumRecoveryDaily',
      groupName: 'Maximum Recovery',
      displayName: 'Maximum Recovery',
      shortName: 'MaximumRecoveryDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_MaximumRecoveryDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    KurtosisDaily: {
      code: 'KurtosisDaily',
      groupName: 'Kurtosis',
      displayName: 'Kurtosis',
      shortName: 'KurtosisDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_KurtosisDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    SterlingRatioDaily: {
      code: 'SterlingRatioDaily',
      groupName: 'Sterling Ratio',
      displayName: 'Sterling Ratio',
      shortName: 'SterlingRatioDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_SterlingRatioDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    CorrelationDaily: {
      code: 'CorrelationDaily',
      groupName: 'Correlation',
      displayName: 'Correlation',
      shortName: 'CorrelationDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_CorrelationDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    AbsoluteDownsideRiskDaily: {
      code: 'AbsoluteDownsideRiskDaily',
      groupName: 'Absolute Downside Risk',
      displayName: 'Absolute Downside Risk',
      shortName: 'AbsoluteDownsideRiskDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_AbsoluteDownsideRiskDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    RelativeDownsideRiskDaily: {
      code: 'RelativeDownsideRiskDaily',
      groupName: 'Relative Downside Risk',
      displayName: 'Relative Downside Risk',
      shortName: 'RelativeDownsideRiskDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_RelativeDownsideRiskDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    TStatisticDaily: {
      code: 'TStatisticDaily',
      groupName: 'T Statistic',
      displayName: 'T Statistic',
      shortName: 'TStatisticDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_TStatisticDaily_XXXXXXXX',
      },
      applicableGroup: ['Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({
        decimalPlaces: 2,
        maxDecimalPlaces: 2,
        includeMax: false,
      }),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      isRFApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
      isIHAllBenchmark: true,
    },
    TargetDownsideRiskDaily: {
      code: 'TargetDownsideRiskDaily',
      groupName: 'Target Downside Risk',
      displayName: 'Target Downside Risk',
      shortName: 'TargetDownsideRiskDaily',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
        {
          chartType: 'Basic Bar',
          iconName: 'chart_bar',
        },
      ],
      workspaceType: ['Rate of Return'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_TargetDownsideRiskDaily_XXXXXXXX',
      },
      applicableGroup: ['Account', 'Benchmark'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      isFrequencyApplicable: true,
      applicableTimeperiods: greaterThanMonthTimeperiods,
    },
    FeeFlow: {
      code: 'FeeFlow',
      groupName: 'Fee Flow',
      displayName: 'Fee Flow',
      shortName: 'FeeFlow',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeFlow_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeePercent: {
      code: 'FeePercent',
      groupName: 'Fee Percent',
      displayName: 'Fee Percent',
      shortName: 'FeePercent',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeePercent_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FlatFee: {
      code: 'FlatFee',
      groupName: 'Flat Fee',
      displayName: 'Flat Fee',
      shortName: 'FlatFee',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FlatFee_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeeSourceRateOfReturn: {
      code: 'FeeSourceRateOfReturn',
      groupName: 'Fee Source Rate Of Return',
      displayName: 'Fee Source Rate Of Return',
      shortName: 'FeeSourceRateOfReturn',
      symbol: '(%)',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'PercentageFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeSourceRateOfReturn_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeeFlowError: {
      code: 'FeeFlowError',
      groupName: 'Fee Flow Error',
      displayName: 'Fee Flow Error',
      shortName: 'FeeFlowError',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeFlowError_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeeSchedule: {
      code: 'FeeSchedule',
      groupName: 'Fee Schedule',
      displayName: 'Fee Schedule',
      shortName: 'FeeSchedule',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'StringFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeSchedule_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeeScheduleMarketValue: {
      code: 'FeeScheduleMarketValue',
      groupName: 'Fee Schedule Market Value',
      displayName: 'Fee Schedule Market Value',
      shortName: 'FeeScheduleMarketValue',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'CurrencyFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeScheduleMarketValue_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
    FeeScheduleValuation: {
      code: 'FeeScheduleValuation',
      groupName: 'Fee Schedule Valuation',
      displayName: 'Fee Schedule Valuation',
      shortName: 'FeeScheduleValuation',
      symbol: '',
      headerLogic: 'useTimePeriod',
      appendToHeader: '',
      fieldLogic: 'useTimePeriod',
      charts: [
      ],
      workspaceType: ['Rate of Return', 'Attribution'],
      formatter: 'DateFormatter',
      customTP: {
        isAnnualizedCumulative: false,
        field: 'Custom_FeeScheduleValuation_XXXXXXXX',
      },
      applicableGroup: ['Account'],
      sideDrawerConfig: setSideDrawerConfig({}),
      isTimePeriodMetric: true,
      applicableTimeperiods: allTimeperiods,
    },
};

/* 
  Below method generates allchartTypes for all the metrics based on metricConfig object
*/
export const getAllChartTypes = () => {
    let chartTypes = [];
    let id=1;
    Object.keys(metricConfig).map(metric => 
        metricConfig[metric].charts.map(chart => { 
            chartTypes.push({id:id,
                metricName:metricConfig[metric]?.groupName,
                displayName: metricConfig[metric]?.displayName,
                chartType:chart?.chartType,
                iconName:chart?.iconName
            });
            id++;
        })
    )
    return chartTypes;
};

/* 
  Below code is foe generating METRIC_NAMES but its yet to be wired as it needs more
  refactoring of the of the existing constants and usage which is out of scope of the ticket.
  This can used by refactoring and reduce the check and make them generic.
*/
export const getMetricNames = (layoutMetricObj) => {
   let metricCode = layoutMetricObj && layoutMetricObj.code != null ? layoutMetricObj.code : Object.keys(metricConfig).find(item => metricConfig[item].groupName === layoutMetricObj?.name); //  || metricConfig[item].code === layoutMetricObj.code
  if (layoutMetricObj?.name === 'Weight' || (layoutMetricObj?.name.startsWith(METRIC_NAME.WEIGHT) && metricCode !== 'WeightedAverageMaturity_WAM_')) {
    metricCode = METRIC_NAME.WEIGHT + layoutMetricObj.averageEnding; // Average -> WeightAverage, Ending -> WeightEnding
  } else if (layoutMetricObj?.name === 'Standard Deviation' || layoutMetricObj?.name.startsWith('Standard Deviation') && metricCode !== 'StandardDeviationSampleDaily') {
    metricCode = METRIC_NAME.STANDARD_DEVIATION.replace(/\s/g, '') + layoutMetricObj.dailyMonthly; // Daily -> StandardDeviationDaily, Monthly -> StandardDeviationMonthly
  } else if ((layoutMetricObj?.name === 'Excess Returns' && layoutMetricObj?.excessReturns == 'Relative') || layoutMetricObj?.name === 'Excess Returns (Relative)') { // with new metrics panel excess return name got changed to support both added extra condition
    metricCode = METRIC_NAME.EXCESS_RETURNS_RELATIVE // In case of relative -> RelativeExcessReturn and for absolute -> will be default ExcessReturns
    // NOTE: if possible need to identify other way how we can determine RelativeExcessReturn code
  } else if (layoutMetricObj?.name === 'Excess Returns (Absolute)' && layoutMetricObj?.excessReturns == 'Absolute') {
    metricCode = METRIC_NAME.EXCESS_RETURNS_API
  } else if (layoutMetricObj?.name === 'Contribution Residual'){
    metricCode = METRIC_NAME.RESIDUAL_API
  } else if (layoutMetricObj?.name === 'Attribution Residual'){
    metricCode = METRIC_NAME.ATTRIBUTION_RESIDUAL_API  
  }
  // console.log('metricConfObje: ' + metricCode)
  return { metricCode: metricCode, metricConfiguation: metricConfig[metricCode] };
}

/* Need to add Metric and MetricAPI when new metric is added */

export const METRIC_NAME = {
    ROR: "Rate of Return",
    ROR_ANNUALIZED: "Annualized",
    ROR_CUMULATIVE: "Cumulative",
    ROR_API: "RateOfReturn",
    ROR_LOCAL: "Rate of Return Local",
    ROR_LOCAL_ANNUALIZED: "Annualized",
    ROR_LOCAL_CUMULATIVE: "Cumulative",
    ROR_LOCAL_API: "RateOfReturnLocal",
    EMV: "Ending Market Value",
    EMV_API: "EndMarketValueWithAccrual",
    EMV_LOCAL: "Ending Market Value Local",
    EMV_LOCAL_API: "EndMarketValueWithAccrualLocal",
    EMV_NOACCRUED_API: "EndMarketValue",
    BMV: "Market Value (Beginning)",
    BMV_API: "BeginMarketValueWithAccrual",
    BMV_LOCAL: "Market Value Local (Beginning)",
    BMV_LOCAL_API: "BeginMarketValueWithAccrualLocal",
    BMV_NOACCRUED_API: "BeginMarketValue",
    CONTRIBUTION: "Contribution",
    CONTRIBUTION_API: "Contribution",
    CONTRIBUTION_RESIDUAL: "Contribution Residual",
    CONTRIBUTION_RESIDUAL_API: "Residual",
    WEIGHT: "Weight",
    WEIGHT_AVERAGE_API: "WeightAverage",
    WEIGHT_ENDING_API: "WeightEnding",
    WEIGHT_AVERAGE_ABSOLUTE: "Weight Average (Total Fund)",
    WEIGHT_ENDING_ABSOLUTE: "Weight Ending (Total Fund)",
    WEIGHT_AVERAGE_ABSOLUTE_API: "WeightAverageAbsolute",
    WEIGHT_ENDING_ABSOLUTE_API: "WeightEndingAbsolute",
    RESIDUAL: "Residual",
    RESIDUAL_API: "Residual",
    STANDARD_DEVIATION: "Standard Deviation",
    STANDARD_DEVIATION_DAILY_API: "StandardDeviationDaily",
    STANDARD_DEVIATION_MONTHLY: "Standard Deviation (Monthly)",
    STANDARD_DEVIATION_MONTHLY_API: "StandardDeviationMonthly",
    ASSET_ALLOCATION: "Asset Allocation",
    ASSET_ALLOCATION_API: "AssetAllocation",    
    TOTAL_MANAGEMENT_EFFECT: "Total Management Effects",    
    TOTAL_MANAGEMENT_EFFECT_API: "TotalManagementEffects",
    STOCK_SELECTION: "Stock Selection",
    STOCK_SELECTION_API: "StockSelection",
    UNHEDGED_CURRENCY: "Unhedged Currency",
    UNHEDGED_CURRENCY_API: "UnhedgedCurrency",
    ATTRIBUTION_RESIDUAL: "Attribution Residual",
    ATTRIBUTION_RESIDUAL_API: "AttributionResidual",
    EXCESS_RETURNS: "Excess Returns",
    EXCESS_RETURNS_API: "ExcessReturns",
    EXCESS_RETURNS_RELATIVE: "RelativeExcessReturn",
    EXCESS_RETURNS_ABSOLUTE_LABEL: "Absolute",
    EXCESS_RETURNS_RELATIVE_LABEL: "Relative",
    INCEPTION_DATE: "Inception Date",
    INCEPTION_DATE_API: "InceptionDate",
    LAST_LOCK_PERFORMANCE: "Last Lock Performance",
    LAST_LOCK_PERFORMANCE_API: "lastlockperformance",
    LAST_LOCK_CLIENT: "Last Lock Client",
    LAST_LOCK_CLIENT_API:"lastlockclient",
    PLUS_FLOW: "Plus Flow",
    PLUS_FLOW_API: "PlusFlow",
    MINUS_FLOW: "Minus Flow",
    MINUS_FLOW_API: "MinusFlow",
    BEGIN_ACCURAL: "Beginning Accrual",
    BEGIN_ACCURAL_API: "BeginAccrual",
    END_ACCURAL: "Ending Accrual",
    END_ACCURAL_API: "EndAccrual",
    BEGIN_ADJUSTMENT: "Beginning Adjustment",
    BEGIN_ADJUSTMENT_API: "BeginAdjustment",
    ACTIVE_SHARE: "Active Share",
    ACTIVE_SHARE_API: "ActiveShare",
    TRACKING_ERROR: "Tracking Error",
    TRACKING_ERROR_API: "TrackingError",
    INTERNAL_ROR: "IRR",
    INTERNAL_ROR_API: "InternalROR",
    MONTH_FORWARD_EPS: "12 Month Forward EPS",
    MONTH_FORWARD_EPS_API: '_12MonthForwardEPS',
    MONTH_TRAILING_EPS: "12 Month Trailing EPS",
    MONTH_TRAILING_EPS_API: '_12MonthTrailingEPS',
    YEAR_DIVIDEND_GROWTH_RATE: "5 Year Dividend Growth Rate",
    YEAR_DIVIDEND_GROWTH_RATE_API: '_5YearDividendGrowthRate',
    YEAR_SALES_GROWTH_RATE: "5 Year Sales Growth Rate",
    YEAR_SALES_GROWTH_RATE_API: '_5YearSalesGrowthRate',
    YEARS_EPS_GROWTH: "5 Years EPS Growth",
    YEARS_EPS_GROWTH_API: '_5YearsEPSGrowth',
    DEBT_TO_CAPITAL: "Debt To Capital",
    DEBT_TO_CAPITAL_API: 'DebtToCapital',
    DEBT_TO_EQUITY: "Debt To Equity",
    DEBT_TO_EQUITY_API: 'DebtToEquity',
    DIVIDEND_YIELD: "Dividend Yield",
    DIVIDEND_YIELD_API: 'DividendYield',
    EFFECTIVE_DURATION: "Effective Duration",
    EFFECTIVE_DURATION_API: 'EffectiveDuration',
    MARKET_CAP: "Market Cap",
    MARKET_CAP_API: 'MarketCap',
    PE_RATIO_TRAILING: "PE Ratio Trailing",
    PE_RATIO_TRAILING_API: 'P_E',
    PRICE_TO_BOOK_RATIO: "Price To Book Ratio",
    PRICE_TO_BOOK_RATIO_API: 'PriceToBookRatio',
    PRICE_TO_CASH_FLOW_RATIO: "Price To Cash Flow Ratio",
    PRICE_TO_CASH_FLOW_RATIO_API: 'PriceToCashFlowRatio',
    PRICE_TO_SALES_RATIO: "Price To Sales Ratio",
    PRICE_TO_SALES_RATIO_API: 'PriceToSalesRatio',
    RETURN_ON_ASSETS: "Return On Assets",
    RETURN_ON_ASSETS_API: 'ReturnOnAssets',
    RETURN_ON_CAPITAL: "Return On Capital",
    RETURN_ON_CAPITAL_API: 'ReturnOnCapital',
    RETURN_ON_EQUITY: "Return On Equity",
    RETURN_ON_EQUITY_API: 'ReturnOnEquity',
    WEIGHTED_AVERAGE_MATURITY: "Weighted Average Maturity",
    WEIGHTED_AVERAGE_MATURITY_API: "WeightedAverageMaturity_WAM_",
    AVERAGE_LIFE: "Average Life",
    AVERAGE_LIFE_API: "AverageLive",
    YIELD_TO_MATURITY: 'Yield To Maturity',
    YIELD_TO_MATURITY_API: 'YieldToMaturity',
    YIELD_TO_OPTION: "Yield To Option",
    YIELD_TO_OPTION_API: 'YieldToOption',
    YIELD_TO_PUT: "Yield To Put",
    YIELD_TO_PUT_API: "YieldToPut",
    ZERO_VOLATILITY_SPREAD: "Zero Volatility Spread",
    ZERO_VOLATILITY_SPREAD_API: "ZeroVolatilitySpread_ZVO_",
    NOMINAL_SPREAD: "Nominal Spread",
    NOMINAL_SPREAD_API: "NominalSpread",
    MACAULAY_DURATION: "Macaulay Duration",
    MACAULAY_DURATION_API: "MacaulayDuration",
    MODIFIED_DURATION: "Modified Duration",
    MODIFIED_DURATION_API: "ModifiedDuration",
    DURATION_TO_WORST: "Duration To Worst",
    DURATION_TO_WORST_API: "DurationToWorst",
    OPTION_ADJUSTED_SPREAD: "Option Adjusted Spread",
    OPTION_ADJUSTED_SPREAD_API: "OptionAdjustedSpread_OAS_",
    EFFECTIVE_DURATION_SPOT: "Effective Duration  Spot",
    EFFECTIVE_DURATION_SPOT_API: "EffectiveDurationSpot",
    CONVEXITY_TO_SPOT: "Convexity To Spot",
    CONVEXITY_TO_SPOT_API: "ConvexityToSpot",
    CONVEXITY_TO_PAR: "Convexity To PAR",
    CONVEXITY_TO_PAR_API: "ConvexityToPAR",
    BARRA_SIZE: "BARRA Size",
    BARRA_SIZE_API: "BARRASize",
    BARRA_VALUE: "BARRA Value",
    BARRA_VALUE_API: "BARRAValue",
    BARRA_MOMENTUM: "BARRA Momentum",
    BARRA_MOMENTUM_API: "BARRAMomentum",
    BARRA_GROWTH: "BARRA Growth",
    BARRA_GROWTH_API: "BARRAGrowth",
    BARRA_LIQUIDITY: "BARRA Liquidity",
    BARRA_LIQUIDITY_API: "BARRALiquidity",
    BARRA_LEVERAGE: "BARRA Leverage",
    BARRA_LEVERAGE_API: "BARRALeverage",
    BARRA_TRADING_ACTIVITY_US : "BARRA Trading Activity (US)",
    BARRA_TRADING_ACTIVITY_US_API : "BARRATrading_Activity_US_",
    ASSET_COUNT: "Asset Count",
    ASSET_COUNT_API: 'AssetCount',
    NET_FLOW: "Net Flow",
    NET_FLOW_API: 'NetFlow',
    GAIN_LOSS: "Gain Loss",
    GAIN_LOSS_API: 'GainLoss',
    DOWNSIDE_MARKET_CAPTURE_RATIO_DAILY: "Downside Market Capture Ratio",
    DOWNSIDE_MARKET_CAPTURE_RATIO_DAILY_API: 'DownsideMarketCaptureRatioDaily',
    INFORMATION_RATIO_DAILY: 'Information Ratio',
    INFORMATION_RATIO_DAILY_API: 'InformationRatioDaily',
    R_SQUARED_DAILY: 'R-Squared',
    R_SQUARED_DAILY_API: 'RSquaredDaily',
    STANDARD_DEVIATION_SAMPLE_DAILY: 'Standard Deviation (Sample)',
    STANDARD_DEVIATION_SAMPLE_DAILY_API: 'StandardDeviationSampleDaily',
    UPSIDE_MARKET_CAPTURE_RATIO_DAILY: 'Upside Market Capture Ratio',
    UPSIDE_MARKET_CAPTURE_RATIO_DAILY_API: 'UpsideMarketCaptureRatioDaily',
    ONE_YEAR_EPS_GROWTH: '1 Year EPS Growth',
    ONE_YEAR_EPS_GROWTH_API: '_1YearEPSGrowth',
    SHARP_RATIO_DAILY: 'Sharpe Ratio',
    SHARP_RATIO_DAILY_API: 'SharpeRatioDaily',
    BETA_DAILY: 'Beta',
    BETA_DAILY_API: 'BetaDaily',
    JENSEN_ALPHA_DAILY: 'Jensen Alpha',
    JENSEN_ALPHA_DAILY_API: 'JensenAlphaDaily',
    SORTINO_RATIO_DAILY: 'Sortino Ratio',
    SORTINO_RATIO_DAILY_API: 'SortinoRatioDaily',
    DOWNSIDE_DEVIATION_DAILY: 'Downside Deviation',
    DOWNSIDE_DEVIATION_DAILY_API: 'DownsideDeviationDaily',
    SEDOL: 'SEDOL',
    SEDOL_API: 'SEDOL',
    CUSIP: 'CUSIP',
    CUSIP_API: 'CUSIP', 
    ISIN : 'ISIN', 
    ISIN_API : 'ISIN',
    TICKER: 'TICKER',
    TICKER_API: 'TICKER',
    AIP_INSTRUMENTID: 'AIP Instrument ID',
    AIP_INSTRUMENTID_API: 'AIPInstrumentID',
    OMNIUM_ASSETID: 'Omnium Asset ID',
    OMNIUM_ASSETID_API: 'OmniumAssetID',
    ASSET_CURRENCY: 'Asset Currency',
    ASSET_CURRENCY_API: 'AssetCurrency',
    ASSET_ISSUE_TYPE: 'Asset Issue Type',
    ASSET_ISSUE_TYPE_API: 'AssetIssueType',
    ASSET_NAME: 'Asset Name',
    ASSET_NAME_API: 'AssetName',
    ASSET_NAME_BBRG: 'Asset Name Bloomberg',
    ASSET_NAME_BBRG_API: 'AssetNameBBRG',
    COUNTRY_OF_DOMICILE: 'Country Of Domicile',
    COUNTRY_OF_DOMICILE_API: 'CountryOfDomicile',
    ISSUER_NAME: 'Issuer Name',
    ISSUER_NAME_API: 'IssuerName',
    TREYNOR_RATIO_DAILY: 'Treynor Ratio',
    TREYNOR_RATIO_DAILY_API: 'TreynorRatioDaily',
    MAXIMUM_DRAWDOWN_DAILY: 'Maximum Drawdown',
    MAXIMUM_DRAWDOWN_DAILY_API: 'MaximumDrawdownDaily',
    CALMAR_RATIO_DAILY: 'Calmar Ratio',
    CALMAR_RATIO_DAILY_API: 'CalmarRatioDaily',
    RELATIVE_TRACKING_ERROR: "Relative Tracking Error",
    RELATIVE_TRACKING_ERROR_API: "RelativeTrackingErrorDaily",
    SKEWNESS_DAILY: 'Skewness',
    SKEWNESS_DAILY_API: 'SkewnessDaily',
    MAXIMUM_RECOVERY_DAILY: 'Maximum Recovery',
    MAXIMUM_RECOVERY_DAILY_API: 'MaximumRecoveryDaily',
    KURTOSIS_DAILY: 'Kurtosis',
    KURTOSIS_DAILY_API: 'KurtosisDaily',
    STERLING_RATIO_DAILY: 'Sterling Ratio',
    STERLING_RATIO_DAILY_API: 'SterlingRatioDaily',
    CORRELATION_DAILY: 'Correlation',
    CORRELATION_DAILY_API: 'CorrelationDaily',
    ABSOLUTE_DOWNSIDE_DAILY: 'Absolute Downside Risk',
    ABSOLUTE_DOWNSIDE_DAILY_API: 'AbsoluteDownsideRiskDaily',
    RELATIVE_DOWNSIDE_RISK_DAILY: 'Relative Downside Risk',
    RELATIVE_DOWNSIDE_RISK_DAILY_API: 'RelativeDownsideRiskDaily',
    T_STATISTIC_DAILY: 'T Statistic',
    T_STATISTIC_DAILY_API: 'TStatisticDaily',
    TARGET_DOWNSIDE_DAILY: 'Target Downside Risk',
    TARGET_DOWNSIDE_DAILY_API: 'TargetDownsideRiskDaily',
    FEE_FLOW: 'Fee Flow',
    FEE_FLOW_API: 'FeeFlow',
    FEE_PERCENT: 'Fee Percent',
    FEE_PERCENT_API: 'FeePercent',
    FLAT_FEE: 'Flat Fee',
    FLAT_FEE_API: 'FlatFee',
    FEE_SOURCE_RATE_OF_RETURN: 'Fee Source Rate Of Return',
    FEE_SOURCE_RATE_OF_RETURN_API: 'FeeSourceRateOfReturn',
    FEE_FLOW_ERROR: 'Fee Flow Error',
    FEE_FLOW_ERROR_API: 'FeeFlowError',
    FEE_SCHEDULE: 'Fee Schedule',
    FEE_SCHEDULE_API: 'FeeSchedule',
    FEE_SCHEDULE_MARKET_VALUE: 'Fee Schedule Market Value',
    FEE_SCHEDULE_MARKET_VALUE_API: 'FeeScheduleMarketValue',
    FEE_SCHEDULE_VALUATION: 'Fee Schedule Valuation',
    FEE_SCHEDULE_VALUATION_API: 'FeeScheduleValuation',
  };
  
/* Formatter type for formating the metrics */
export const FORMATTER_TYPE = {
  PERCENTAGE: 'PercentageFormatter',
  CURRENCY: 'CurrencyFormatter',
  DATE: 'DateFormatter',
  NULL: 'NullFormatter',
  STRING: 'StringFormatter'
};

// Autonomus_Metrics are those which work independently or works with non-independent metrics for making a RPM Metrics call
// Whenever new metrics are added we need to test the combination and if it works independent and with non-independent metrics then we need to add them to Autonomus_Metrics
// ToBeAdded_Metrics is a sample dummy ROR metric which is added to non-independent metrics to amke a succesful RPM call
// Below config can be removed when all metrics are independently supported by RPM Calls.
export const SUPPLEMENTARY_METRICS = {
    Autonomus_Metrics: ['Rate of Return', 'Weight', 'Standard Deviation', 'Stock Selection', 'Unhedged Currency', 'Asset Allocation', 'Total Management Effects'],
    ToBeAdded_Metrics: {
        "name": "Rate of Return",
        "nameOverride": null,
        "timePeriod": {
            "displayName": "Daily",
            "name": "Daily"
        },
        "customTimePeriod": null,
        "decimalPlaces": 2,
        "residuals": false,
        "dailyMonthly": "",
        "averageEnding": "",
        "fixedTrailing": "",
        "annualizedCumulative": "",
        "excessReturns": ""
    },
}

// metrics.ts constants

export const CUSTOM_TIME_PERIOD_TYPE_OPTIONS = {
    DAYS: "Days",
    WEEKS: "Weeks",
    MONTHS: "Months",
    YEARS: "Years",
}

/* List used in metric.ts */
export const BLACK_LISTED_METRIC = {
    Account: ["Excess Returns"],
    Benchmark: ["Ending Market Value"],
    Attribution: [],
}

/* Dropdown options for metrics side bar */

const getMetricsDropdownOptions = (metricsList) => {
  let sideDrawerOptions = {};
  Object.keys(metricsList).forEach((key) => {
    sideDrawerOptions = {...sideDrawerOptions,  
      [metricsList[key].groupName]: {
      name: metricsList[key].groupName,
      displayName: metricsList[key]?.sideDrawerConfig?.sidePanelDisplayName !== null ? metricsList[key].sideDrawerConfig.sidePanelDisplayName : metricsList[key].displayName,
      ...metricsList[key].sideDrawerConfig
    }}
  });
  return sideDrawerOptions;
};
export const MetricsObjectsDropdownOptions =  getMetricsDropdownOptions(metricConfig);

export const defaultMetrics = [
  {
    metric: "EndMarketValueWithAccrual",
    timeperiod: null
  },
  {
    metric: "RateOfReturn",
    timeperiod: "MTD"
  }];

export const defaultTSMetrics = [
  {
    metric: "EndMarketValueWithAccrual",
    timeperiod: null
  },
  {
    metric: "RateOfReturn",
    timeperiod: null
  }];

// console.log('MetricsObjectsDropdownOptions', MetricsObjectsDropdownOptions)
